import { useContext } from "react";
import { AppContext } from "../../app-context";
import { setLocale as setLocaleApi } from "../apis/set-locale";

export const useLocale = () => {
  const { locale, setLocale } = useContext(AppContext);

  const setLocaleInternal = (locale: string) => {
    const updateLocale = async () => {
      await setLocaleApi(locale);
      setLocale(locale);
    };

    updateLocale();
  };

  return { locale, setLocale: setLocaleInternal };
};
